/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiResponse, CreateGuildRequest } from 'models'

import axiosClient from './axiosClient'

const guildApi = {
  createGuild(body: CreateGuildRequest): Promise<ApiResponse<string>> {
    const url = `/guilds`
    return axiosClient.post(url, body)
  },

  putEditGuild(guildId: any, params: any): Promise<ApiResponse<string>> {
    const url = `/guilds/${guildId}`
    return axiosClient.post(url, params, { headers: { 'Content-Type': 'multipart/form-data' } })
  },

  getGuildMaterData(): Promise<ApiResponse<string>> {
    const url = '/guilds/guild-master-data'
    return axiosClient.get(url)
  },

  getGuildInformation(): Promise<ApiResponse<string>> {
    const url = '/guilds/information'
    return axiosClient.get(url)
  },

  getUpgradeGuild(guildId: string): Promise<ApiResponse<string>> {
    const url = `/guilds/${guildId}/info/upgrade-guild`
    return axiosClient.get(url)
  },

  postUpgradeGuild(guildId: string): Promise<ApiResponse<string>> {
    const url = `/guilds/${guildId}/upgrade-level`
    return axiosClient.post(url)
  },

  getListGuild(params: any): Promise<ApiResponse<string>> {
    const url = `/guilds/guilds-list`
    return axiosClient.get(url, { params })
  },

  getListGuildMember(guildId: string | number, params: any): Promise<ApiResponse<string>> {
    const url = `/guilds/members/${guildId}`
    return axiosClient.get(url, { params })
  },

  joinGuild(guildId: number): Promise<ApiResponse<string>> {
    const url = `/guilds/join-guilds/${guildId}`
    return axiosClient.post(url)
  },

  getGuildInfomationById(guildId: string | number): Promise<ApiResponse<string>> {
    const url = `/guilds/information/${guildId}`
    return axiosClient.get(url)
  },

  getGuildInfomation(): Promise<ApiResponse<string>> {
    const url = '/guilds/information'
    return axiosClient.get(url)
  },

  getRaceParticipationGuild(guildId: string | number): Promise<ApiResponse<string>> {
    const url = `/guild/races/participation/conditions/${guildId}`
    return axiosClient.get(url)
  },

  getGuildManager(): Promise<ApiResponse<string>> {
    const url = '/guilds/information'
    return axiosClient.get(url)
  },

  putRoleUserGuild(guildId: number, userId: number | string, params: any): Promise<ApiResponse<string>> {
    const url = `/guilds/${guildId}/members/${userId}/roles`
    return axiosClient.put(url, { ...params })
  },

  getGuildMember(userId: string | number): Promise<ApiResponse<string>> {
    const url = `/guilds/member/${userId}`
    return axiosClient.get(url)
  },

  userLeaveGuild(guildId: string | number): Promise<ApiResponse<string>> {
    const url = `/guilds/${guildId}/leave-guild`

    return axiosClient.put(url)
  },

  putKickMemberOutGuild(guildId: string | number, memberId: number): Promise<ApiResponse<string>> {
    const url = `/guilds/${guildId}/members/${memberId}/kick`

    return axiosClient.put(url)
  },

  addMembertoBlackList(guildId: string | number, memberId: number): Promise<ApiResponse<string>> {
    const url = `/guilds/${guildId}/add/${memberId}/user-black-list`
    return axiosClient.put(url)
  },

  getGuildFarms(guildId: string | number, params: any): Promise<ApiResponse<string>> {
    const url = `/guilds/guild-farms/${guildId}`
    return axiosClient.get(url, { params })
  },

  getYourHorseGuildFarms(params: any): Promise<ApiResponse<string>> {
    const url = `/guilds/guild-farms`
    return axiosClient.get(url, { params })
  },

  getMyHorsesInFarm(params: any): Promise<ApiResponse<any>> {
    const url = `/guilds/my-horses`
    return axiosClient.get(url, { params })
  },

  getAvailableMyHorses(params: any): Promise<ApiResponse<any>> {
    const url = `/guilds/my-horses/available`
    return axiosClient.get(url, { params })
  },

  postAddHorseGuildFarm(data: any): Promise<ApiResponse<any>> {
    const url = '/guilds/add-horse'
    return axiosClient.post(url, data)
  },

  postCheckNonce(data: any): Promise<ApiResponse<any>> {
    const url = '/guilds/check-nonce'
    return axiosClient.post(url, data)
  },

  getHorseGuildDetails(horseId: number | string): Promise<ApiResponse<any>> {
    const url = `/guilds/guild-farms/horses/${horseId}`
    return axiosClient.get(url)
  },

  getMemberDetails(guildId: number | string, userId: number | string): Promise<ApiResponse<any>> {
    const url = `/guilds/${userId}/${guildId}/member-detail`
    return axiosClient.get(url)
  },

  getMyProfile(): Promise<ApiResponse<any>> {
    const url = `/guilds/my-profile`
    return axiosClient.get(url)
  },

  postWithrawHorse(data: any): Promise<ApiResponse<any>> {
    const url = '/guilds/withdraw-horse'
    return axiosClient.post(url, data)
  },

  editProfitGuild(guildId: string | number, params: any): Promise<ApiResponse<string>> {
    const url = `/guilds/${guildId}/profit-percentage`

    return axiosClient.put(url, { ...params })
  },

  postSendToGuild(horseId: number | string, params: any): Promise<ApiResponse<any>> {
    const url = `/guilds/guild-farms/horses/${horseId}/send-to-market`
    return axiosClient.post(url, params)
  },

  postHorseRentGuild(horseId: number | string, params: any): Promise<ApiResponse<any>> {
    const url = `/guilds/guild-farms/horses/${horseId}/rent`
    return axiosClient.post(url, params)
  },

  postHorseBackToFarm(horseId: number | string): Promise<ApiResponse<any>> {
    const url = `/guilds/guild-farms/horses/${horseId}/back-to-farm`
    return axiosClient.post(url)
  },

  postWithdrawFromMarket(horseId: number | string): Promise<ApiResponse<any>> {
    const url = `/guilds/guild-farms/horses/${horseId}/withdraw-from-market`
    return axiosClient.post(url)
  },

  getTopHorses(guildId: number | string): Promise<ApiResponse<any>> {
    const url = `/guilds/${guildId}/top-horses`
    return axiosClient.get(url)
  },

  getTopMembers(guildId: number | string): Promise<ApiResponse<any>> {
    const url = `/guilds/${guildId}/top-members`
    return axiosClient.get(url)
  },

  getTopOwners(guildId: number | string): Promise<ApiResponse<any>> {
    const url = `/guilds/${guildId}/top-owners`
    return axiosClient.get(url)
  },

  putHorseToGuild(horseId: number | string, guildId: number | string): Promise<ApiResponse<any>> {
    const url = `/guilds/${horseId}/${guildId}/to-guild-farm`
    return axiosClient.put(url)
  },

  putWithdrawFromGuild(horseId: number | string): Promise<ApiResponse<any>> {
    const url = `/guilds/${horseId}/withdraw-from-guild`
    return axiosClient.put(url)
  },

  getHorseOwner(guildId: number | string, params: any): Promise<ApiResponse<any>> {
    const url = `/guilds/horse-owner/${guildId}`
    return axiosClient.get(url, { params })
  },

  getRaceHistory(guildId: string | number, params: any): Promise<ApiResponse<string>> {
    const url = `/guilds/${guildId}/races-history`
    return axiosClient.get(url, { params })
  },

  putHorseArrToGuild(guildId: number | string, params: any): Promise<ApiResponse<any>> {
    const url = `/guilds/${guildId}/to-guild-farm`
    return axiosClient.put(url, params)
  },

  getMyHorses(params: any): Promise<ApiResponse<any>> {
    const url = '/guilds/guild-farms/my-horses'
    return axiosClient.get(url, { params })
  },

  getMemberRaceHistory(guildId: string | number, userId: string | number, params: any): Promise<ApiResponse<string>> {
    const url = `/guilds/${userId}/${guildId}/member-races-history`
    return axiosClient.get(url, { params })
  },

  getHorseRaceHistory(guildId: string | number, horseId: string | number, params: any): Promise<ApiResponse<string>> {
    const url = `/guilds/${horseId}/${guildId}/horse-races-history`
    return axiosClient.get(url, { params })
  },

  putHorseToBlackListFromGuild(guildId: number | string, tokenId: number | string): Promise<ApiResponse<any>> {
    const url = `/guilds/${guildId}/add/${tokenId}/horse-black-list`
    return axiosClient.put(url)
  },

  postEntryCondition(guildId: string | number, totalRace: string | number, params: any): Promise<ApiResponse<string>> {
    const url = `/guilds/${guildId}/entry-condition/${totalRace}`
    return axiosClient.put(url, { ...params })
  },

  postDisband(guildId: string | number): Promise<ApiResponse<string>> {
    const url = `/guilds/${guildId}/disband`
    return axiosClient.post(url)
  },

  postCedeTo(guildId: number, userId: number | string): Promise<ApiResponse<string>> {
    const url = `/guilds/${guildId}/cede-to/${userId}/master-guild`
    return axiosClient.post(url)
  },

  putSendToBlacklist(guildId: number, userId: number | string): Promise<ApiResponse<string>> {
    const url = `/guilds/${guildId}/add/${userId}/user-black-list`
    return axiosClient.put(url)
  },

  getListGuildApplication(guildId: string | number, params: any): Promise<ApiResponse<string>> {
    const url = `/guilds/${guildId}/application`
    return axiosClient.get(url, { params })
  },

  getListGuildRace(guildId: string | number, params: any): Promise<ApiResponse<string>> {
    const url = `/guild/races/${guildId}/list`
    return axiosClient.get(url, { params })
  },

  getGuildRewardSetting(guildId: string | number, params: any): Promise<ApiResponse<string>> {
    const url = `/guild/rewards-setting/${guildId}/list`
    return axiosClient.get(url, { params })
  },

  postGuildDeleteTemplate(rewardPackageId: string | number): Promise<ApiResponse<any>> {
    const url = `/guild/rewards-setting/delete/${rewardPackageId}`
    return axiosClient.post(url)
  },

  getGuildRewardSettingDetail(packageId: number): Promise<ApiResponse<string>> {
    const url = `/guild/rewards-setting/detail/${packageId}`
    return axiosClient.get(url)
  },

  getParentSubType(type: string): Promise<ApiResponse<string>> {
    const url = `/guild/rewards-setting/parent-sub-type/${type}`
    return axiosClient.get(url)
  },

  getDesignatedItem(type: string): Promise<ApiResponse<string>> {
    const url = `/guild/rewards-setting/designatedItem/${type}`
    return axiosClient.get(url)
  },

  getRarity(itemName: string): Promise<ApiResponse<string>> {
    const url = `/guild/rewards-setting/rarity-type/${itemName}`
    return axiosClient.get(url)
  },

  postCreateRewardSetting(body: any): Promise<ApiResponse<any>> {
    const url = '/guild/rewards-setting/add'
    return axiosClient.post(url, body)
  },

  postUpdateRewardSetting(guildId: string | number, body: any): Promise<ApiResponse<any>> {
    const url = `/guild/rewards-setting/update/${guildId}`
    return axiosClient.put(url, body)
  },

  getVaultCoinReward(guildId: string | number, params: any): Promise<ApiResponse<any>> {
    const url = `/guild/vault/${guildId}/coin-rewards`
    return axiosClient.get(url, { params })
  },

  getNftItemsNotUsed(guildId: string | number, body: any, params: any): Promise<ApiResponse<any>> {
    const url = `/guild/vault/${guildId}/items/exclude-ids`
    return axiosClient.post(url, body, { params })
  },

  postCreateRace(guildId: string | number, body: any): Promise<ApiResponse<any>> {
    const url = `/guild/races/create/${guildId}`
    return axiosClient.post(url, body)
  },

  postRaceParticipationGuild(guildId: string | number, body: any): Promise<ApiResponse<any>> {
    const url = `/guild/races/participation/conditions/${guildId}`
    return axiosClient.post(url, body)
  },

  getVaultNftReward(guildId: string | number, params: any): Promise<ApiResponse<any>> {
    const url = `/guild/vault/${guildId}/item-rewards`
    return axiosClient.get(url, { params })
  },

  getVaultNonNftReward(guildId: string | number, params: any): Promise<ApiResponse<any>> {
    const url = `/guild/vault/${guildId}/booster-rewards`
    return axiosClient.get(url, { params })
  },

  getVaultTicketReward(guildId: string | number, params: any): Promise<ApiResponse<any>> {
    const url = `/guild/vault/${guildId}/ticket-rewards`
    return axiosClient.get(url, { params })
  },

  postDonateCoin(body: any): Promise<ApiResponse<any>> {
    const url = `/guild/vault/donate-coins`
    return axiosClient.post(url, body)
  },

  postDonateItems(body: any): Promise<ApiResponse<any>> {
    const url = `/guild/vault/donate-items`
    return axiosClient.post(url, body)
  },

  postDonateNonNft(body: any): Promise<ApiResponse<any>> {
    const url = `/guild/vault/donate-boosters`
    return axiosClient.post(url, body)
  },

  postDonateTicketNft(body: any): Promise<ApiResponse<any>> {
    const url = `/guild/vault/donate-tickets`
    return axiosClient.post(url, body)
  },

  postCheckNonceGuildAdil(data: any): Promise<ApiResponse<any>> {
    const url = '/guild/vault/check-nonce'
    return axiosClient.post(url, data)
  },

  getListGuildUserBlacklist(guildId: string | number, params: any): Promise<ApiResponse<string>> {
    const url = `/guilds/${guildId}/user-blacklist`
    return axiosClient.get(url, { params })
  },

  getListGuildHorseBlacklist(guildId: string | number, params: any): Promise<ApiResponse<string>> {
    const url = `/guilds/${guildId}/horse-blacklist`
    return axiosClient.get(url, { params })
  },

  getApplicationMemberDetails(guildId: number | string, userId: number | string): Promise<ApiResponse<any>> {
    const url = `/guilds/${guildId}/detail/${userId}/application`
    return axiosClient.get(url)
  },

  putGuildMasterWithdraw(params: any): Promise<ApiResponse<string>> {
    const url = `/guilds/master/withdraw`
    return axiosClient.put(url, params)
  },

  putAppove(guildId: number, userId: number | string): Promise<ApiResponse<string>> {
    const url = `/guilds/${guildId}/approve/${userId}/join`
    return axiosClient.put(url)
  },

  putReject(guildId: number, userId: number | string): Promise<ApiResponse<string>> {
    const url = `/guilds/${guildId}/reject/${userId}/join`
    return axiosClient.put(url)
  },

  getUserBlacklistDetails(guildId: number | string, userId: number | string): Promise<ApiResponse<any>> {
    const url = `/guilds/${guildId}/detail/${userId}/blacklist`
    return axiosClient.get(url)
  },

  putCancelUserBlacklist(guildId: number, userId: number | string): Promise<ApiResponse<string>> {
    const url = `/guilds/${guildId}/cancel/${userId}/user-black-list`
    return axiosClient.put(url)
  },

  getHorseBlacklistDetails(guildId: number | string, horseId: number | string): Promise<ApiResponse<any>> {
    const url = `/guilds/${guildId}/detail/${horseId}/horse-blacklist`
    return axiosClient.get(url)
  },

  putCancelHorseBlacklist(guildId: number, horseId: number | string): Promise<ApiResponse<string>> {
    const url = `/guilds/${guildId}/cancel/${horseId}/horse-black-list`
    return axiosClient.put(url)
  },

  getOptionItemType(): Promise<ApiResponse<any>> {
    const url = `/guild/rewards-setting/item-type`
    return axiosClient.get(url)
  },

  getOptionCollection(itemType: string): Promise<ApiResponse<any>> {
    const url = `/guild/rewards-setting/collection/${itemType}`
    return axiosClient.get(url)
  },

  getOptionItemName(collection: string): Promise<ApiResponse<any>> {
    const url = `/guild/rewards-setting/item-name/${collection}`
    return axiosClient.get(url)
  },

   getOptionItemNameV2(collection: string): Promise<ApiResponse<any>> {
    const url = `/guild/rewards-setting/item-name/avatar/${collection}`
    return axiosClient.get(url)
  },

  getVaultItems(guildId: string | number, params: any): Promise<ApiResponse<any>> {
    const url = `/guild/vault/${guildId}/items`
    return axiosClient.get(url, { params })
  },

  postTransferCoin(guildId: string | number, total: number, typeItem : string): Promise<ApiResponse<string>> {
    const url = `/guild/vault/deposit-vault/guild-revenue/${guildId}/${typeItem}/${total}`
    return axiosClient.post(url)
  },

  postDepositVault(guildId: string | number, body: any): Promise<ApiResponse<string>> {
    const url = `/guild/vault/deposit-vault/guild-revenue/${guildId}`
    return axiosClient.post(url, body)
  },

  checkConditionUpgrade(guildId: string | number): Promise<ApiResponse<string>> {
    const url = `/guilds/${guildId}/validate-upgrade-level`
    return axiosClient.post(url)
  },
}

export default guildApi
